export default __webpack_public_path__ + "static/media/disinfectant.bfd5cce3.svg";